export interface IMenuItem {
    name: string;
    link: string;
    active: boolean;
    icon: string;
    isPersonDependent: boolean;
    click?: ($event: any, drawer: any) => {};
}